<div class="dialog-content">
    <h3 class="dialog-title">
        <img
            class="dialog-icon dialog-icon--primary"
            [src]="iconPaths.ALERT_CIRCLE"
            alt="Error"
            width="22"
            height="22"
        />
        {{ data.title }}
    </h3>
    <p class="dialog-message">
        {{ data.message }}
    </p>
    <div class="dialog-actions">
        <button class="dialog-button dialog-button--primary" (click)="handleConfirmClick()">
            {{ data.confirmText || defaultTexts.ERROR.confirmText }}
        </button>
    </div>
</div>
